import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { CarrierVisitDirection, GateDirection } from '@planning/app/api'
import { IGateClerkViewStore } from '@planning/stores/gateClerk/GateClerkViewStore'
import { useTranslate } from '@tolgee/react'
import { ContainerMobile, Header, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useEffect } from 'react'
import { HeaderAvatar } from './../TallymanV2/Components/HeaderComponents/HeaderAvatar'
import { useSelectedGateLabel } from './hooks/useSelectedGateLabel'
import { ExitGateMismatchDialog } from './Components/ExitGateMismatchDialog'
import { GatePassageResultAlert } from './Components/GatePassageResultAlert'
import { TruckDirection } from './Components/TruckDirection'

interface IProps {
  store: IGateClerkViewStore
  navigateNext: (operation: CarrierVisitDirection) => void
}

export const SelectOperation: FC<IProps> = observer(({ store, navigateNext }) => {
  const { notificationStore } = store
  const { gateSessionStore } = usePlanningStore()

  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  // Direction-aware availability: movements the bound session gate does not permit stay
  // visible but disabled, so clerks see the option exists and is unavailable at their gate.
  const gateDirection = gateSessionStore.boundGate?.direction
  const canGateIn = gateDirection === GateDirection.In || gateDirection === GateDirection.Both
  const canGateOut = gateDirection === GateDirection.Out || gateDirection === GateDirection.Both
  const title =
    t('gateClerk', 'Gate Clerk') + (store.selectedGang?.name ? ` - ${store.selectedGang.name}` : '')
  const gateLabel = useSelectedGateLabel()
  const setOperation = (operation: CarrierVisitDirection) => {
    store.setOperation(operation)
    notificationStore.reset()

    navigateNext(operation)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Header title={title} subTitle={gateLabel} rightRenderOption={<HeaderAvatar />} />
      <Box style={{ backgroundColor: theme.palette.grey[200], minHeight: '100vh' }}>
        <ContainerMobile sx={{ pt: theme.customSpacing.l }}>
          <GatePassageResultAlert store={notificationStore} />
          <ExitGateMismatchDialog store={notificationStore} />
          <TruckDirection
            direction={CarrierVisitDirection.Inbound}
            disabled={!canGateIn}
            onClick={() => setOperation(CarrierVisitDirection.Inbound)}
          />
          <TruckDirection
            direction={CarrierVisitDirection.Outbound}
            disabled={!canGateOut}
            onClick={() => setOperation(CarrierVisitDirection.Outbound)}
          />
        </ContainerMobile>
      </Box>
    </>
  )
})
